// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.review-guide[data-v-3f65a0b4] {
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #4b5158;
}
.review-list[data-v-3f65a0b4] {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}
.review-table[data-v-3f65a0b4] {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.review-table th[data-v-3f65a0b4],
.review-table td[data-v-3f65a0b4] {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  vertical-align: top;
}
/* 이름·아이디·마지막 로그인은 한 줄로(좁으면 「정다운」이 한 글자씩 꺾임, 10-31 intest I14) */
.review-table th[data-v-3f65a0b4]:nth-child(-n + 3),
.review-table td[data-v-3f65a0b4]:nth-child(-n + 3) {
  white-space: nowrap;
}
.review-table th[data-v-3f65a0b4] {
  position: sticky;
  top: 0;
  background: #fafafa;
  font-weight: 600;
  color: #333;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
